import { faCertificate, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  SOCIAL_CUES,
  SHOW_MARKETING_CLAIM_DEFINITIONS,
} from '../../brands/default/features';
import { MARKETING_CLAIMS_DEF_LINK } from '../../brands/default/links';
import ThemeContext from '../../providers/ThemeProvider';

const SocialCueMainDeal = ({ cue, className = '', isStarMarked = false }) => {
  const theme = useContext(ThemeContext);

  if (!cue) {
    return null;
  }

  if (!SOCIAL_CUES && isStarMarked) {
    return null;
  }

  return (
    <>
      <p
        className={classNames('main-deal-social-cue', className)}
        data-testid="cue"
      >
        <FontAwesomeIcon icon={faCertificate} />
        <span>{cue}</span>
        {isStarMarked && SHOW_MARKETING_CLAIM_DEFINITIONS && (
          <FontAwesomeIcon
            icon={faInfoCircle}
            onClick={() => {
              window.open(MARKETING_CLAIMS_DEF_LINK, '_blank');
            }}
            style={{
              cursor: 'pointer', // This makes the cursor change to a pointer when hovering
              marginLeft: '0.5rem',
            }}
          />
        )}
      </p>
      <style jsx>{`
        .main-deal-social-cue {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 8px;
            text-wrap: balance;
        }
        .main-deal-social-cue--assure {
          color: ${theme.colors.socialcuecolor.assure};
        }
        .main-deal-social-cue--alert {
          color: ${theme.colors.socialcuecolor.alert};
        }
        .main-deal-social-cue--authentic {
          margin-bottom: 8px;
            color: #3c78aa;
        }
        .main-deal-social-cue--no-margin {
          margin: 0;
        }
        :global(.main-deal-social-cue svg) {
          margin-right 8px;
        }
      `}</style>
    </>
  );
};

SocialCueMainDeal.propTypes = {
  className: PropTypes.string,
  cue: PropTypes.string,
  isStarMarked: PropTypes.bool,
};

export default SocialCueMainDeal;
